import React from 'react';
import ProtectedRoute from '../../Components/ProtectedRoute';
import { LogRelatory, LogRelatoryViewController } from "../../Screen/LogRelatory/LogRelatoryViewController";
import { LogRelatoryViewModel } from '../../Screen/LogRelatory/LogRelatoryViewModel';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";

export class LogRelatoryCoordinator implements IndexCoordinatorDelegate, LogRelatory {

    getRoute(): JSX.Element[] {
        return [
            this.routeLogRelatory(),
        ]
    }

    private routeLogRelatory(): JSX.Element {
        var viewModel = new LogRelatoryViewModel()
        return (<ProtectedRoute requiredPermissions={['relatorios.logs.*']} path="/:base/relatorio/logs" exact={true} component={(props: any) => {
            return (<LogRelatoryViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
}